import { RefObject } from 'react';

export const scrollToRef = (refContainer?: RefObject<HTMLDivElement | null>): void => {
  setTimeout(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: refContainer ? refContainer.current?.offsetTop : 0,
    });
  }, 100);
};
